var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import StatusType from "@irati/wallet/types/enums/Status";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import rewardLogo from "@irati-web/reward/src/images/reward.png";
import authentication from "@irati/auth";
import Card from "@irati/ui/src/Layout/Card";
import ExpanderItem from "../../../ExpanderItem";
import PrimaryDetails from "../../../PrimaryDetails";
import SecondaryDetails from "../../../SecondaryDetails/SendCreditAsReward";
var StyledSecondaryDetails = styled(SecondaryDetails)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var StyledImg = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 130px;\n"], ["\n  width: 130px;\n"])));
var StyledCard = styled(Card)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 20px;\n  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);\n"], ["\n  margin-bottom: 20px;\n  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);\n"])));
var SendCreditAsReward = /** @class */ (function (_super) {
    __extends(SendCreditAsReward, _super);
    function SendCreditAsReward() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.returnSubtitle = function () {
            var _a = _this.props, isRewardWallet = _a.isRewardWallet, statementItem = _a.statementItem, formatMessage = _a.formatMessage;
            var rewardOrder = statementItem.transfer.sendCreditAsReward.rewardOrder;
            return isRewardWallet ? "\n      " + formatMessage({ id: "wallet.statementItem.sendCreditAsReward.primaryDetails.rewardWallet.subTitle" }) + "\n      " + firstnameLastname(rewardOrder.recipients.results[0]) + "\n    " : "\n      " + formatMessage({ id: "wallet.statementItem.sendCreditAsReward.primaryDetails.subTitle" }) + "\n      " + firstnameLastname(rewardOrder.createdBy) + "\n    ";
        };
        return _this;
    }
    SendCreditAsReward.prototype.render = function () {
        var _a = this.props, statementItem = _a.statementItem, className = _a.className, isRewardWallet = _a.isRewardWallet;
        var transfer = statementItem.transfer;
        var amount = transfer.amount, sendCreditAsReward = transfer.sendCreditAsReward;
        var rewardOrder = sendCreditAsReward.rewardOrder;
        var currency = authentication.defaultUserCurrency();
        var primaryDetails = {
            image: rewardOrder.reward.thumbnailImage,
            title: React.createElement(StyledImg, { src: rewardLogo, alt: "" }),
            subTitle: this.returnSubtitle(),
            amount: amount,
            currency: currency,
            status: isRewardWallet ? StatusType.SPENT : StatusType.CLEARED
        };
        var secondaryDetails = {
            currency: currency,
            rewardedBy: firstnameLastname(rewardOrder.createdBy),
            transactionAmount: amount
        };
        var idNamespace = id("send-credit-as-reward", this.props);
        if (isRewardWallet) {
            return (React.createElement(StyledCard, { tiny: true, noBorder: true },
                React.createElement(PrimaryDetails, { id: idNamespace, data: primaryDetails })));
        }
        return (React.createElement(ExpanderItem, { className: className, id: idNamespace, PrimaryElement: function () { return React.createElement(PrimaryDetails, { id: idNamespace, data: primaryDetails }); }, SecondaryElement: React.createElement(StyledSecondaryDetails, { id: idNamespace, data: secondaryDetails }) }));
    };
    SendCreditAsReward.defaultProps = {
        isRewardWallet: false
    };
    return SendCreditAsReward;
}(PureComponent));
export default injectIntl(SendCreditAsReward);
var templateObject_1, templateObject_2, templateObject_3;
